
export const getQueryParams = (obj: any) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p) && obj[p] !== null) {
      let reqParam = obj[p];
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(reqParam));
    }
  return str.join('&');
}
